export const white = "#FFFFFF"; // rgb(255,255,255)
export const black = "#16161D";
export const gray1 = "#222222";
export const gray2 = "#333333";
export const gray3 = "#4F4F4F";
export const gray4 = "#828282";
export const gray5 = "#BDBDBD";
export const gray6 = "#E0E0E0";
export const gray7 = "#F2F2F2";
export const gray8 = "#F9F9F9";
export const gray9 = "#F0F0F0";
export const gray10 = "#8D8D8D";

export const lightGray = "#FBFBFB";
export const silver = "#C4C4C4";

export const greenDark = "#1BBF83";
export const green = "#35D48D";
export const greenLight = "#76E8AD";

export const error = "#F24147";
export const redDark = "#F24147";
export const red = "#FF5D5D";
export const redLightColor = "#FF8E89";

export const mainPoint = "#82C5BE";
export const mainMint = "#83B9BD";
export const mainColor = "#5CC8BC";
export const mainSub1Color = "#B2CFD2";
export const mainSub2Color = "#E1ECED";
export const mainDark1Color = "#69A0A6";
export const mainDark2Color = "#548085";
export const mainDark3Color = "#406063";
export const mainDark4Color = "#2A4042";

export const classGreenColor = "#45ADA2";
export const classDreamColor = "#E37E7A";
export const kakaoColor = "#FFDE00";
export const naverColor = "#58B93E";
export const darkColor = "#787880";
export const iris = "#A5A6F6";
export const blueLight = "#007AFF";
export const blue = "#5D93D0";
export const beige = "#f3f3f3";
